import { getWindowLocationValues } from './helpers'

/**
 * Track form field error events
 *
 * @param {object} statsigClient
 * @param {object} event
 * @param {string} event.field
 * @param {string[]} event.errors
 * @param {object} event.scope
 */
export function trackFormFieldErrorEvent(
  statsigClient,
  { field, errors, scope },
) {
  if (field === undefined || !Array.isArray(errors)) return

  statsigClient?.logEvent('form_field_error', field, {
    field_name: field,
    // We don't have a reliable field_type in chimera yet.
    // To uphold to the event contract, we do sent it along empty.
    field_type: '',
    field_validation_rule: errors[0],
    form_id: scope?.form_id,
    step_id: scope?.step_id,
    form_entry_point: scope?.form_entry_point,
    ...getWindowLocationValues(scope),
  })
}
